import axios from 'axios'

export class Schnellkacheln{
    static async get(){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/schnellkacheln`
            );

            // Hier kannst du die Daten weiterverarbeiten oder in der Komponente verwenden
            var schnellkacheln = response.data;
            console.log(response);
            return schnellkacheln;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
